import { runtimeValue } from "../runtime-config";

// Resolved at container start from the server's environment (see
// src/runtime-config.ts); falls back to the build-time .env values.
const tenant = runtimeValue("TENANT", process.env.REACT_APP_TENANT);

export const APP_CONFIG = {
  tenant: tenant || "ERP System",
  isUhbGroup: tenant === "UHB GROUP",
  siteName:
    runtimeValue("SITE_NAME", process.env.REACT_APP_SITE_NAME) || "ERP System",
};
